import React from "react";
import * as TogglePrimitive from "@radix-ui/react-toggle";

interface ToggleProps {
  pressed?: boolean;
  defaultPressed?: boolean;
  onPressedChange?: (pressed: boolean) => void;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  className?: string;
  children?: React.ReactNode;
  title?: string;
  "aria-label"?: string;
}

/**
 * Toggle component wrapping Radix UI Toggle primitive.
 * Used for binary on/off states (scramble toggles, etc.).
 *
 * Supports both controlled (pressed) and uncontrolled (defaultPressed) modes.
 */
export const Toggle = React.forwardRef<HTMLButtonElement, ToggleProps>(
  (
    {
      pressed,
      defaultPressed,
      onPressedChange,
      disabled,
      className,
      children,
      ...props
    },
    forwardedRef
  ) => {
    return (
      <TogglePrimitive.Toggle
        ref={forwardedRef}
        pressed={pressed}
        defaultPressed={defaultPressed}
        onPressedChange={onPressedChange}
        disabled={disabled}
        className={`inline-flex items-center justify-center rounded border-2 transition-colors font-medium focus:outline-none focus:ring-2 focus:ring-purple-400 focus:ring-offset-2 focus:ring-offset-gray-950 disabled:opacity-50 disabled:cursor-not-allowed ${
          className || ""
        }`}
        {...props}
      >
        {children}
      </TogglePrimitive.Toggle>
    );
  }
);

Toggle.displayName = "Toggle";

export default Toggle;
